import { z } from 'zod';

export const editAddressSchema = z.object({
  addressName: z
    .string()
    .min(1, 'Address name is required')
    .max(50, 'Address name must be at most 50 characters'),
  address: z.string().min(1, 'Address is required'),
  city: z.string().optional(),
  state: z.string().optional(),
  zipcode: z.string().optional(),
  country: z.string().optional(),
  bedroom: z.number().min(1, 'At least 1 bedroom is required'),
  bathroom: z.number().min(1, 'At least 1 bathroom is required'),
  people: z.number().min(1, 'At least 1 person is required'),
  pet: z.number().min(0, 'Pet count cannot be negative'),
  cleaningAreaSize: z.string().min(1, 'Please select a cleaning area size'),
  houseDescription: z
    .string()
    .max(500, 'Description must be at most 500 characters')
    .optional(),
  latitude: z.number(),
  longitude: z.number(),
});

export type EditAddressFormData = z.infer<typeof editAddressSchema>;
